let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3WZqP")).then(() => parcelRequire('i0yfM'));